import React, { useEffect, useRef, useState } from 'react';
import Dialog from './TivigoDialog';
import CircularProgress from '@mui/material/CircularProgress';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import './userPanelRemoveUserModal.css';

function UserPanelRemoveUserModal({ open, onClose, username, onConfirm }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inFlightRef = useRef(false);

  useEffect(() => {
    if (!open) return;
    setError('');
    setLoading(false);
    inFlightRef.current = false;
  }, [open]);

  const confirmRemoval = async () => {
    if (inFlightRef.current || typeof onConfirm !== 'function') return;
    inFlightRef.current = true;
    setLoading(true);
    setError('');
    try {
      await onConfirm();
      onClose?.();
    } catch (requestError) {
      setError(requestError?.message || 'Kullanıcı kaldırılamadı.');
    } finally {
      setLoading(false);
      inFlightRef.current = false;
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth={false}
      transitionDuration={0}
      disableEscapeKeyDown
      className="tvup-remove-user-dialog"
      aria-labelledby="tvup-remove-user-title"
      aria-describedby="tvup-remove-user-description"
      slotProps={{
        backdrop: { className: 'tvup-remove-user-backdrop' },
        paper: { id: 'tvup-remove-user-modal', className: 'tvup-remove-user-modal' },
      }}
    >
      <header>
        <span><DeleteOutlineRoundedIcon /></span>
        <div><h2 id="tvup-remove-user-title">Kullanıcıyı Kaldır</h2><p>Bu işlem yalnızca alt kullanıcılar içindir.</p></div>
        <button type="button" aria-label="Kullanıcı kaldırma penceresini kapat" disabled={loading} onClick={onClose}><CloseRoundedIcon /></button>
      </header>
      <section>
        <span className="tvup-remove-user-warning"><WarningAmberRoundedIcon /></span>
        <h3><b>{username || 'Bu kullanıcı'}</b> hesabınızdan kaldırılacak.</h3>
        <p id="tvup-remove-user-description">Kullanıcının süresi ve ayarları devam edecek ancak artık alt kullanıcı listenizde görünmeyecek.</p>
        <strong>Bu işlem geri alınamaz.</strong>
        {error && <div role="alert">{error}</div>}
      </section>
      <footer>
        <button type="button" disabled={loading} onClick={onClose}>İptal</button>
        <button type="button" disabled={loading || typeof onConfirm !== 'function'} onClick={confirmRemoval}>
          {loading ? <><CircularProgress size={17} thickness={5} /> Kaldırılıyor</> : 'Kaldır'}
        </button>
      </footer>
    </Dialog>
  );
}

export default UserPanelRemoveUserModal;
